import {useEffect, useRef} from "react";

/**
 * Sérialise les rechargements déclenchés par la révision live de la campagne.
 * Si plusieurs révisions arrivent pendant une requête lente, elles sont
 * coalescées en un seul rechargement supplémentaire.
 */
export default function useSerializedRefresh(task, revision)
{
    const taskRef=useRef(task)
    const runningRef=useRef(false)
    const queuedRef=useRef(false)
    const mountedRef=useRef(false)
    taskRef.current=task

    useEffect(()=>{
        mountedRef.current=true
        return ()=>{ mountedRef.current=false }
    },[])

    useEffect(()=>{
        queuedRef.current=true

        const drain=async()=>{
            if(runningRef.current){ return }
            runningRef.current=true
            try{
                while(mountedRef.current && queuedRef.current){
                    queuedRef.current=false
                    try{
                        await taskRef.current()
                    }catch(_){
                        // Garder l'état valide précédent ; la prochaine révision réessaiera.
                    }
                }
            }finally{
                runningRef.current=false
            }
        }

        drain()
    },[revision])
}
